import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, Button } from '@/components/ui'

/**
 * Το κάτω μέρος της δήλωσης «δεν έχω όλες τις ποσότητες», κοινό για το email
 * και το portal του προμηθευτή.
 *
 * Η αιτιολογία είναι υποχρεωτική: ο πελάτης που ζήτησε 10 και βλέπει 6 χωρίς
 * εξήγηση νομίζει ότι του άλλαξαν την παραγγελία (feedback πελάτη 22/10).
 */
export function PartialSubmit({
  items,
  quantities,
  loading,
  onSubmit,
  onCancel,
}: {
  items: { id: string; quantity: string }[]
  quantities: Record<string, string>
  loading: boolean
  onSubmit: (note: string) => void
  onCancel: () => void
}) {
  const { t } = useTranslation()
  const [reason, setReason] = useState('')
  const [problem, setProblem] = useState<string | null>(null)

  const changed = items.some(
    (item) => item.id in quantities && Number(quantities[item.id]) !== Number(item.quantity),
  )

  const submit = () => {
    if (!changed) return setProblem(t('public.noChange'))
    if (!reason.trim()) return setProblem(t('public.reasonRequired'))
    setProblem(null)
    onSubmit(reason.trim())
  }

  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm text-gray-600">{t('public.declareHint')}</p>

      <div className="flex flex-col gap-1.5">
        <label htmlFor="partial-reason" className="text-sm font-medium text-gray-700">
          {t('public.reasonLabel')}
        </label>
        <textarea
          id="partial-reason"
          rows={2}
          maxLength={500}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          placeholder={t('public.reasonPlaceholder')}
          className="rounded-xl border border-gray-300 bg-white p-3 text-base text-gray-900 outline-none focus:border-brand-600 focus:ring-2 focus:ring-brand-100"
        />
      </div>

      {problem && <Alert tone="warning">{problem}</Alert>}

      <Button loading={loading} onClick={submit}>
        {t('public.sendQuantities')}
      </Button>
      <Button variant="secondary" onClick={onCancel}>
        {t('common.cancel')}
      </Button>
    </div>
  )
}
